import { getContext } from '@fiverr-private/fiverr_context';

const MOBILE_WEB = 'mobile_web';
const WEB = 'web';

export const getPlatform = () => (getContext().isTouch ? MOBILE_WEB : WEB);

export const once = (callback) => {
    let called = false;

    return (...args) => {
        if (!called) {
            callback(...args);
            called = true;
        }
    };
};
